<template>
  <v-layout
    align-center
    wrap
  >
    <template v-for="(member, index) in members">
      <v-flex
        v-if="selected.includes(member.id)"
        :key="index"
        xs12
        class="mb-3"
        :class="[{ 'personal-form personal-form_bordered': member?.complete }]"
      >
        <v-layout>
          <v-flex
            class="mt-4 mr-2"
            :shrink="lgAndUp"
          >
            <span class="fw-600 f-2 text-dark">{{ indexNum(index) }}</span>
          </v-flex>
          <v-flex>
            <v-layout wrap>
              <v-flex
                v-if="member.hasOwnProperty('name')"
                lg3
                md12
                :class="[{ 'pr-3': $vuetify.breakpoint.mdAndUp }]"
              >
                <v-text-field
                  :disabled="readOnly"
                  :value="member.name"
                  class="personal-input_disabled"
                />
              </v-flex>
              <v-flex
                v-if="
                  getExpensesForMedicineQuestions.disabled_members.hasOwnProperty(
                    'disability_cause'
                  )
                "
                lg6
                md12
                :class="[{ 'px-3': $vuetify.breakpoint.lgAndUp }]"
              >
                <v-textarea
                  v-model.trim="member.reasonForDisability"
                  v-validate="{
                    ...regularLongText(
                      getExpensesForMedicineQuestions.disabled_members.disability_cause.required,
                      180
                    )
                  }"
                  :label="getExpensesForMedicineQuestions.disabled_members.disability_cause.label"
                  :disabled="readOnly"
                  :error-messages="errors.collect(createDataName('disease', member.id))"
                  :data-vv-as="$t('label.disease')"
                  :data-vv-name="createDataName('disease', member.id)"
                  :required="
                    getExpensesForMedicineQuestions.disabled_members.disability_cause.required
                  "
                  :rows="1"
                  auto-grow
                  @blur="completePersonData(member.id)"
                  @focus="falseComplete(member.complete)"
                />
              </v-flex>
              <v-flex
                v-if="
                  getExpensesForMedicineQuestions.disabled_members.hasOwnProperty(
                    'member_independence'
                  )
                "
                lg6
                md12
                class="offset-lg3 mt-3"
                :class="[{ 'px-3': $vuetify.breakpoint.lgAndUp }]"
              >
                <BaseRadio
                  v-model="member.memberIndependence"
                  :name="createDataName('disabled_memberIndependence', member.id)"
                  :values="memberIndependenceResources"
                  value-key="id"
                  label-key="description"
                  :required="
                    getExpensesForMedicineQuestions?.disabled_members?.member_independence?.required
                  "
                  :label="
                    getExpensesForMedicineQuestions.disabled_members.member_independence.label
                  "
                  :disabled="readOnly"
                />
              </v-flex>
              <v-flex
                v-if="
                  getExpensesForMedicineQuestions.disabled_members.hasOwnProperty(
                    'monthly_cost_of_treatment'
                  )
                "
                lg8
                md12
                class="offset-lg3"
                :class="[{ 'px-3': $vuetify.breakpoint.lgAndUp }]"
              >
                <v-text-field
                  v-model="member.monthlyCostOfTreatment"
                  v-validate="{
                    ...requiredMoney(
                      getExpensesForMedicineQuestions.disabled_members.monthly_cost_of_treatment
                        .required
                    )
                  }"
                  :disabled="readOnly"
                  :label="
                    getExpensesForMedicineQuestions.disabled_members.monthly_cost_of_treatment.label
                  "
                  :suffix="$t('label.amount_suffix')"
                  :error-messages="
                    errors.collect(createDataName('disabled_monthly_cost_of_treatment', member.id))
                  "
                  :data-vv-as="$t('label.amount_on_medicine')"
                  :data-vv-name="createDataName('disabled_monthly_cost_of_treatment', member.id)"
                  inputmode="decimal"
                  @blur="completePersonData(member.id)"
                  @focus="falseComplete(member.complete)"
                />
              </v-flex>
              <v-flex
                v-if="getExpensesForMedicineQuestions.disabled_members.hasOwnProperty('note')"
                xs12
                class="mt-4"
              >
                <v-textarea
                  v-model="member.note"
                  v-validate="{
                    ...regularLongText(
                      getExpensesForMedicineQuestions.disabled_members.note.required,
                      1800
                    )
                  }"
                  :disabled="readOnly"
                  :label="getExpensesForMedicineQuestions.disabled_members.note.label"
                  :error-messages="errors.collect(createDataName('regular_field', member.id))"
                  :data-vv-as="$t('label.question')"
                  :data-vv-name="createDataName('regular_field', member.id)"
                  :placeholder="member.complete ? '-' : $t('sheet.enter_text')"
                  class="small"
                  auto-grow
                  @blur="completePersonData(member.id)"
                  @focus="falseComplete(member.complete)"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider
          v-if="index < members.length - 1"
          class="mt-3"
        />
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';
import filters from '@/constants/filters';
import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';

import { mapGetters } from 'vuex';
import BaseRadio from '../BaseRadio.vue';

export default {
    name: 'DisabledMembersForm',
    filters: {
        ...filters
    },
    mixins: [sheetValidationRules, sheetResourcesGetter],
    inject: ['$validator'],
    props: {
        members: {
            type: Array,
            default: () => {
                return [
                    {
                        monthlyCostOfTreatment: 0
                    }
                ];
            }
        },
        selected: {
            type: Array,
            default: () => {
                return [];
            }
        },
        readOnly: {
            default: false
        }
    },
    data () {
        return {
            membersLabels: []
        };
    },
    computed: {
        ...mapGetters('sheet', ['getExpensesForMedicineQuestions']),
        lgAndUp () {
            return this.$vuetify.breakpoint.lgAndUp;
        },
        memberIndependenceResources () {
            return this.getResources(
                this.getExpensesForMedicineQuestions.disabled_members.member_independence
            );
        }
    },
    methods: {
        indexNum (index) {
            return index + 1 + '.';
        },
        createDataName (name, id) {
            return name + id;
        },
        completePersonData (id) {
            this.members.forEach((el) => {
                if (el.id === id) {
                    const _keys = [];
                    Object.keys(this.fields).forEach((key) => {
                        if (key.indexOf(id) !== -1) {
                            _keys.push(this.fields[key]);
                        }
                    });
                    el.complete = Object.keys(_keys).every((key) => _keys[key].valid);
                }
            });
        },
        falseComplete (el) {
            el = false;
        }
    },
    components: { BaseRadio }
};
</script>

<style scoped></style>
